/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Loader from 'react-loader';
import styles from './Schedule.module.css'


import 'react-datepicker/dist/react-datepicker.css';

moment.locale('ru', {
  months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
  weekdaysMin: 'Пн_Вт_Ср_Чт_Пт_Сб_Вс'.split('_'),
});

export default class ScheduleOnDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment()
    };
    this.handleChange = this.handleChange.bind(this);
    this.renderClass = this.renderClass.bind(this);
  }

  handleChange(date) {
    const { didMount } = this.props;
    didMount(moment(date).format('YYYY-MM-DD'))
    this.setState({
      startDate: date
    });
  }

  componentDidMount() {
    const { didMount } = this.props;
    const { startDate } = this.state;
    window.scrollTo(0, 0);
    didMount(moment(startDate).format('YYYY-MM-DD'))
  }
  renderClass(elem, i) {
    return (
      <tr key={i}>
        <td>{elem.period}<br />{elem.start} - {elem.stop}</td>
        <td>{elem.meta_course_name}</td>
        <td>{elem.rooms}</td>
        <td>{elem.teachers}</td>
        <td>{elem.homework}</td>
      </tr>
    );
  }
  render() {
    const { isLoading, schedule } = this.props;
    const { startDate } = this.state;
    return (
      <div className="26.jpg upper">
        <Loader
          color="#7b2b2a"
          loaded={!isLoading}
        >
          <div className='date-picker-wrap' >
            <div className="captions">Индивидуальное расписание занятий на </div>
            <DatePicker
              dateFormat={'DD.MM.YYYY'}
              selected={startDate}
              onChange={this.handleChange}
              className='date-picker'
              showYearDropdown
            />
          </div>
          <div className={styles.tableContainer}>
            <table className=" new__tg_med newWidth">
              <tr>
                <th>Часы занятий</th>
                <th>Дисциплина</th>
                <th>Аудитория</th>
                <th>Преподаватель</th>
                <th>Задание</th>
              </tr>
              <tbody>
                {schedule && schedule.map(this.renderClass)}
              </tbody>
            </table>
          </div>
        </Loader>
      </div>
    );
  }
}

